import { useEffect, useState } from "react";

export type ConnectivityState = "online" | "offline-ready" | "offline-first-load";

export function useConnectivity(): ConnectivityState {
  const [online, setOnline] = useState(() => navigator.onLine);
  const [cached, setCached] = useState(
    () => "serviceWorker" in navigator && Boolean(navigator.serviceWorker.controller),
  );

  useEffect(() => {
    let active = true;
    const checkAppOrigin = async () => {
      if (!navigator.onLine) {
        if (active) {
          setOnline(false);
        }
        return;
      }

      try {
        const response = await fetch("/", {
          method: "HEAD",
          cache: "no-store",
          credentials: "same-origin",
        });
        if (active) {
          setOnline(response.ok);
        }
      } catch {
        if (active) {
          setOnline(false);
        }
      }
    };
    const handleOnline = () => void checkAppOrigin();
    const handleOffline = () => setOnline(false);
    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    void checkAppOrigin();

    if ("serviceWorker" in navigator) {
      void navigator.serviceWorker.ready.then(() => {
        if (active) {
          setCached(true);
        }
      });
    }

    return () => {
      active = false;
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (online) {
    return "online";
  }
  return cached ? "offline-ready" : "offline-first-load";
}
